
	import Accordion from "primevue/accordion";
	import Card from "primevue/card";
	import Divider from "primevue/divider";
	import Panel from "primevue/panel";
	import CompentencyHeaderTitle from "@/components/CompentencyHeaderTitle.vue";

	import { usePlugin } from "@/plugins";
	import {
		defineComponent,
		// watch,
		// computed,
		// ref,
		// onBeforeUpdate,
		// onMounted,
		// reactive,
		ref,
	} from "vue";

	export default defineComponent({
		name: "compentencyAssessment",
		components: {
			CompentencyHeaderTitle,
		},
		setup() {
			const { dayjs } = usePlugin();
			const fiscalYear = () => dayjs().toDate().getFullYear() + 543;

			const assmtTemplateP1 = ref([
				{
					abbrv: "T",
					desc: "ทีมงานร่วมใจ (Teamwork and Collaboration)",
					taskDescs: [
						{ taskDesc: "จัดการทำงานและติดตามงานของทีม" },
						{ taskDesc: "สร้างความร่วมมือระหว่างทีม" },
						{ taskDesc: "ชื่นชม สร้างแรงจูงใจในการทำงานเป็นทีม" },
						{ taskDesc: "ร่วมสุขร่วมทุกข์และร่วมรับผิดชอบกับทีมงาน" },
					],
				},
				{
					abbrv: "A",
					desc: "ใฝ่เรียนรู้เป็นนิจ (Ability to Learn)",
					taskDescs: [
						{ taskDesc: "สามารถประยุกต์ใช้ความรู้ให้เกิดผลงานอย่างโดดเด่น" },
						{
							taskDesc:
								"เรียนรู้อย่างลึกซึ้งและเชื่อมโยงความรู้ด้านอื่นๆเพื่อการทำงานภาพรวมอย่างมีประสิทธิภาพ",
						},
						{
							taskDesc:
								"สร้างความไว้วางใจและบรรยากาศที่เอื้อต่อการแลกเปลี่ยนเรียนรู้ของทีม",
						},
					],
				},
				{
					abbrv: "S",
					desc:
						"คิดอย่างผู้ประกอบการ (Seek Opportunity and Act as an Entrepreneur)",
					taskDescs: [
						{
							taskDesc:
								"แสวงหาโอกาสในการทำงานเพื่อประโยชน์ของธุรกิจอย่างผู้ประกอบการ",
						},
						{
							taskDesc:
								"สร้างแรงจูงใจและสนับสนุนทีมงานให้ทำงานอย่างทุ่มเทให้เกิดผลอย่างชัดเจนที่ลูกค้า/ผู้รับบริการ",
						},
					],
				},
				{
					abbrv: "T",
					desc: "สรรค์สร้างสิ่งใหม่ (Think Positively and Act Innovatively)",
					taskDescs: [
						{
							taskDesc:
								"เป็นตัวอย่างการเป็นนักสร้างสรรค์สิ่งใหม่ด้วยตนเอง ที่มีผลงาน  Process/ Product/ Services หรือ Business  Innovation",
						},
						{ taskDesc: "จูงใจทีมงานให้กล้าคิดและสนุกกับการสร้างสรรค์นวัตกรรม" },
					],
				},
				{
					abbrv: "T",
					desc: "มีใจคุณธรรม (Ethics and Integrity) ",
					taskDescs: [
						{
							taskDesc:
								"คิด พูด ทำ ถูกต้องด้วยหลักยุติธรรม คุณธรรม และความถูกต้อง",
						},
						{
							taskDesc:
								"สร้างแรงจูงใจให้ทีมงานคิด พูด ทำ ตามกฎระเบียบจริยธรรมธุรกิจ",
						},
					],
				},
			]);

			const assmtTemplateP2 = ref([
				{
					abbrv: "L",
					desc: "กล้านำการเปลี่ยนแปลง (Leading Change)",
					taskDescs: [
						{ taskDesc: "เท่าทันการเปลี่ยนแปลงแต่ละด้านโดยเฉพาะเทคโนโลยี" },
						{ taskDesc: "จูงใจให้ทีมงานเห็นความจำเป็นในการเปลี่ยนแปลง" },
					],
				},
				{
					abbrv: "E",
					desc: "แสดงวิสัยทัศน์ (Establishing Vision and Business Strategy)",
					taskDescs: [
						{ taskDesc: "พัฒนามุมมองให้กว้างไกลเห็นภาพรวมอุตสาหกรรม" },
						{
							taskDesc:
								"พัฒนากลยุทธ์ในการทำงานร่วมกันระหว่างทีมเพื่อ “ทำน้อยแต่ได้ผลมาก",
						},
						{
							taskDesc:
								"สื่อสารสร้างแรงจูงใจให้ทีมงานทุ่มเท และมุ่งที่เป้าหมายกลยุทธ์ธุรกิจ",
						},
					],
				},
				{
					abbrv: "A",
					desc: "แน่ชัดแล้วตัดสินใจ (Acting as a Problem Solver)",
					taskDescs: [
						{
							taskDesc:
								"ใช้ข้อมูลในการวิเคราะห์คาดการณ์เพื่อการตัดสินใจในงานและการแก้ปัญหา",
						},
						{
							taskDesc:
								"วางแผนงานและแผนความเสี่ยงในงานโดยใช้การวิเคราะห์ข้อมูลและการคาดการณ์ (Analytic)",
						},
						{
							taskDesc: "สร้างแรงจูงใจให้ทีมงานทำงานเชิงรุก พร้อมเผชิญความท้าทาย",
						},
					],
				},
				{
					abbrv: "D",
					desc: "ใส่ใจพัฒนาทีม (Developing Others)",
					taskDescs: [
						{
							taskDesc:
								"มีความรู้ในงาน เปิดรับความรู้อื่นที่สามารถเชื่อมโยงกับการทำงาน",
						},
						{
							taskDesc:
								"สามารถสอนงาน เป็นพี่เลี้ยงและเป็นโค้ช โดยเลือกใช้ได้เหมาะสมกับสถานการณ์",
						},
						{
							taskDesc:
								"จูงใจให้เกิดการเรียนรู้ด้วยตนเองและมีการแลกเปลี่ยนเรียนรู้",
						},
					],
				},
			]);

			const assmtTemplateP3 = ref([
				{
					abbrv: "1",
					desc: "ความรู้เกี่ยวกับงานและธุรกิจบริษัท",
					taskDescs: [
						{ taskDesc: "รอบรู้ภาพรวมบริษัท ช่องทางการขายทั้งหมดใน TT" },
					],
				},
				{
					abbrv: "2",
					desc:
						"ความรู้ด้านผลิตภัณฑ์/Pack size/ช่องทาง/ราคา (BPPC) และ Promotion",
					taskDescs: [
						{
							taskDesc:
								"รอบรู้ผลิตภัณฑ์/Pack size/ช่องทาง/ราคา (BPPC) และ Promotion ของ TT บางหน่วย",
						},
					],
				},
				{
					abbrv: "3",
					desc: "ทักษะการขับรถขนส่งสินค้า",
					taskDescs: [
						{ taskDesc: "สามารถขับรถขนส่งสินค้าและดูแลรักษารถเบื้องต้น" },
					],
				},
				{
					abbrv: "4",
					desc: "ความรู้ด้านความเคลื่อนไหวของตลาด/คู่แข่ง",
					taskDescs: [
						{
							taskDesc:
								"รวบรวมข้อมูล วิเคราะห์ความเคลื่อนไหวของตลาด/คู่แข่งในพื้นที่",
						},
					],
				},
			]);

			return {
				fiscalYear,
				assmtTemplateP1,
				assmtTemplateP2,
				assmtTemplateP3,
			};
		},
	});
